import React from 'react'

// monochrome line icons — stroke = currentColor, so they take the surrounding text color.
// Same visual language as the sun/moon toggle in the top bar.
const S = props => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  />
)

// Today — fork & knife
export const MealsIcon = () => (
  <S>
    <path d="M5 2v5M7 2v5M9 2v5" />
    <path d="M4.5 7h5" />
    <path d="M7 7v15" />
    <path d="M17 2c-1.7 0-3 2.7-3 6s1.3 4 3 4" />
    <path d="M17 2v20" />
  </S>
)

// History — bar chart
export const ChartIcon = () => (
  <S>
    <path d="M3 21h18" />
    <path d="M6 21V11" />
    <path d="M12 21V5" />
    <path d="M18 21v-7" />
  </S>
)

// Foods — leaf
export const LeafIcon = () => (
  <S>
    <path d="M20 4C9 4 4 9 4 15c0 3 2 5 5 5 7 0 11-6 11-16z" />
    <path d="M4 20c4-2 8-6 11-11" />
  </S>
)

// Settings — sliders
export const SlidersIcon = () => (
  <S>
    <path d="M4 8h9M17 8h3" />
    <circle cx="15" cy="8" r="2" />
    <path d="M4 16h3M11 16h9" />
    <circle cx="9" cy="16" r="2" />
  </S>
)

// FAB — camera
export const CameraIcon = () => (
  <S>
    <path d="M3 8.5A1.5 1.5 0 0 1 4.5 7H8l1.2-2h5.6L16 7h3.5A1.5 1.5 0 0 1 21 8.5V18a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18z" />
    <circle cx="12" cy="13" r="3.3" />
  </S>
)

// FAB — plus (log a meal)
export const PlusIcon = () => (
  <S strokeWidth="2">
    <path d="M12 5v14M5 12h14" />
  </S>
)

// Theme — moon / sun (used by the Settings appearance toggle)
export const MoonIcon = () => (
  <S strokeWidth="2">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </S>
)
export const SunIcon = () => (
  <S strokeWidth="2">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </S>
)
